<header class="bciti-dialog__header">
    <div class="bciti-dialog__title">
        {{ 'pages.user-cards.add-existing-user-dialog.title' | translate }}
    </div>
    <button class="bciti-dialog__close-button" (click)="closeDialog()">
        <span  class="icon icon-close"></span>
    </button>
</header>
<div class="bciti-dialog__content">
    <div class="spinner-wrapper" *ngIf="formLoading" >
        <mat-progress-spinner mode="indeterminate" diameter="30"></mat-progress-spinner>
    </div>
    <form *ngIf="!formLoading" [formGroup]="formGroup" id="idAddFamilyMemberForm">
        <div class="form-section-title">{{ 'pages.user-cards.add-existing-user-dialog.subtitle' | translate }}</div>
        <div class="form-group">
            <app-form-input 
                label="{{ 'pages.user-cards.family.common.fields.email.label' | translate }}"
                placeholder="{{ 'pages.user-cards.family.common.fields.email.placeholder' | translate }}"
                formControlName="email"
                [messages]="email.touched && (email.hasError('sameEmail') || email.hasError('email')) ? false : true"
            >
                <app-form-error *ngIf="email.touched && email.hasError('email')">
                    {{ 'pages.user-cards.family.common.errors.invalidEmail' | translate }}
                </app-form-error>
                <app-form-error *ngIf="email.touched && (email.hasError('sameEmail'))">
                    {{ 'pages.user-cards.family.common.errors.sameEmail' | translate }}
                </app-form-error>
            </app-form-input>
        </div>
        <div class="form-group">
            <app-form-input 
                label="{{ 'pages.user-cards.family.common.fields.citizenCardNumber.label' | translate }}"
                placeholder="{{ 'pages.user-cards.family.common.fields.citizenCardNumber.placeholder' | translate }}"
                formControlName="cardCode"
                [messages]="true"
            ></app-form-input>
        </div>
        <div class="form-group">
            <app-form-input 
                label="{{ 'pages.user-cards.family.common.fields.firstName.label' | translate }}"
                placeholder="{{ 'pages.user-cards.family.common.fields.firstName.placeholder' | translate }}"
                formControlName="firstName"
                [messages]="true"
            ></app-form-input>
        </div>
        <div class="form-group">
            <app-form-input 
                label="{{ 'pages.user-cards.family.common.fields.lastName.label' | translate }}"
                placeholder="{{ 'pages.user-cards.family.common.fields.lastName.placeholder' | translate }}"
                formControlName="lastName"
                [messages]="true"
            ></app-form-input>
        </div>
        <div
            class="form-group"
            [ngClass]="{
                'select-valid': sex.touched
            }"
        >
            <app-form-select-user-cards
                label="{{ 'pages.user-cards.family.common.fields.gender.label' | translate }}"
                placeholder="{{ 'pages.user-cards.family.common.fields.gender.placeholder' | translate }}"
                [useOptionAll]="false"
                [options]="sexOptions"
                [selected]="selectedSex"
                (selectChange)="sexChange($event)"
            >
            </app-form-select-user-cards>
        </div>
        <div class="form-group">
            <app-form-datepicker 
                type="tel"
                label="{{ 'pages.user-cards.family.common.fields.birthDate.label' | translate }}" 
                formControlName="birthDate" 
                [max]="maxDate"
                [showMessages]="false"
            >
                <app-form-error *ngIf="birthDate.touched && birthDate.hasError('required')">
                    {{ 'pages.user-cards.family.common.errors.invalidBirthDate' | translate }}
                </app-form-error>
            </app-form-datepicker>
        </div>
        <div
            class="form-group"
            [ngClass]="{
                'select-invalid': targetLink.touched && targetLink.hasError('required'),
                'select-valid': targetLink.touched && targetLink.valid
            }"
        >
            <app-form-select-user-cards
                label="{{ 'pages.user-cards.family.common.fields.link.label' | translate }} *"
                placeholder="{{ 'pages.user-cards.family.common.fields.link.placeholder' | translate }}"
                [useOptionAll]="false"
                [selected]="selectedLink"
                [options]="familyLinks"
                (selectChange)="linkChange($event)"
            >
            </app-form-select-user-cards>
            <div class="messages" *ngIf="targetLink.touched && targetLink.hasError('required')">
                <div class="error">
                    <p>{{ "pages.user-cards.family.error.invalidLink" | translate }}</p>
                </div>
            </div>
        </div>
    </form>
</div>
<footer class="bciti-dialog__footer bciti-dialog__footer--messages">
    <div class="bciti-dialog__messages messages" *ngIf="formGroup.errors?.requiredSearch">
        <div class="error">
            <p>{{ "pages.user-cards.family.common.errors.requiredSearch" | translate }}</p>
        </div>
    </div>
    <button class="bciti-button bciti-button--lightblue-inversed" (click)="closeDialog()">
        {{ 'pages.user-cards.common.button.cancel' | translate }}
    </button>
    <button 
        class="bciti-button" 
        [ngClass]="submitLoading ? 'bciti-button--disabled' : 'bciti-button--blue'" 
        [disabled]="submitLoading"
        (click)="onSubmit()"
    >
        <span *ngIf="!submitLoading">{{ 'pages.user-cards.add-existing-user-dialog.button.search' | translate }}</span>
        <mat-spinner diameter="20" *ngIf="submitLoading"></mat-spinner>
    </button>
</footer>
